export const USER_GROUP_CONSTRAINTS = {
    name: { maxLength: 30, label: 'Role name' },
    description: { maxLength: 256, label: 'Description' },
};
//# sourceMappingURL=constraints.js.map